import Vue from 'vue';
import { stringify } from 'csv-stringify';
import ModalPrompt from 'components/widgets/ModalPrompt.vue';
import Utils from 'src/utils/general';
import Exports from 'src/api/exports';
import { mapGetters } from 'vuex';
import FormatUtils from 'src/utils/formatters';
export default Vue.extend({
    components: { ModalPrompt },
    data() {
        return {
            exportLimit: 100000,
            loading: {
                fullConcepts: false,
                documentConcepts: false,
                frameConcepts: false,
                documentQueries: false,
                frameQueries: false,
                savedQueriesList: false,
            },
            showDataExportLimitModal: false
        };
    },
    computed: {
        ...mapGetters(['currentModel', 'currentAnalysis', 'currentProject', 'currentSite', 'featureFlags', 'expandedSavedQueries']),
    },
    methods: {
        number: FormatUtils.number,
        checkDataExportLimit() {
            this.exportLimit = this.currentSite?.export_limit;
            if (this.currentModel.stats.n_documents > this.exportLimit) {
                this.showDataExportLimitModal = true;
                return false;
            }
            else {
                return true;
            }
        },
        downloadDocumentTopics(event) {
            if (!this.checkDataExportLimit()) {
                return;
            }
            this.loading.documentConcepts = true;
            Exports.getDocumentTopics(this.$store).then((response) => {
                stringify([response.headers].concat(response.rows), (_, csvString) => {
                    Utils.downloadCsv(csvString, 'document-topics');
                });
                this.$analytics.track.analysis.downloadExport('Topics for Documents', 'CSV');
            }).finally(() => {
                this.loading.documentConcepts = false;
            });
        },
        downloadTextExcerptTopics(event) {
            if (!this.checkDataExportLimit()) {
                return;
            }
            this.loading.frameConcepts = true;
            Exports.getTextExcerptTopics(this.$store).then((response) => {
                stringify([response.headers].concat(response.rows), (_, csvString) => {
                    Utils.downloadCsv(csvString, 'verbatim-topics');
                });
                this.$analytics.track.analysis.downloadExport('Topics for Verbatims', 'CSV');
            })
                .finally(() => {
                this.loading.frameConcepts = false;
            });
        },
        async downloadDocumentQueries(event) {
            if (!this.checkDataExportLimit()) {
                return;
            }
            this.loading.documentQueries = true;
            try {
                let data = await Exports.getDocumentSavedQueries(this.currentProject.id, this.currentAnalysis.id, this.expandedSavedQueries);
                // If they navigate away from this page, the download will still happen. We've thought about this
                // and made peace with it 🧘
                stringify([data.headers].concat(data.rows), (_, csvString) => {
                    Utils.downloadCsv(csvString, 'document-themes');
                });
                this.$analytics.track.analysis.downloadExport('Themes for Documents', 'CSV');
            }
            finally {
                this.loading.documentQueries = false;
            }
        },
        async downloadTextExcerptQueries(event) {
            if (!this.checkDataExportLimit()) {
                return;
            }
            this.loading.frameQueries = true;
            try {
                let data = await Exports.getTextExcerptSavedQueries(this.currentProject.id, this.currentAnalysis.id, this.expandedSavedQueries);
                // If they navigate away from this page, the download will still happen. We've thought about this
                // and made peace with it 🧘
                stringify([data.headers].concat(data.rows), (_, csvString) => {
                    Utils.downloadCsv(csvString, 'verbatim-themes');
                });
                this.$analytics.track.analysis.downloadExport('Themes for Verbatims', 'CSV');
            }
            finally {
                this.loading.frameQueries = false;
            }
        },
        async downloadFullExport() {
            this.loading.fullConcepts = true;
            try {
                const res = await Exports.getExportConcepts(this.currentAnalysis.project, this.currentAnalysis.id);
                stringify([res.headers].concat(res.rows), (_, csvString) => {
                    Utils.downloadCsv(csvString, 'concepts');
                });
                this.$analytics.track.analysis.downloadExport('Detailed Concepts', 'CSV');
            }
            finally {
                this.loading.fullConcepts = false;
            }
        },
        async downloadSavedQueriesList() {
            this.loading.savedQueriesList = true;
            try {
                const res = await Exports.getSavedQueriesList(this.currentAnalysis.project, this.currentAnalysis.id);
                Utils.downloadTxt(res.text, 'themes');
                this.$analytics.track.analysis.downloadExport('Themes List', 'TXT');
            }
            finally {
                this.loading.savedQueriesList = false;
            }
        }
    }
});
